import { FiscalYear } from 'models';

import isDateIntersectsWithFiscalYear from './isDateIntersectsWithFiscalYear';

export default function isCurrentFiscalYear(fiscalYear: FiscalYear) {
  let today = new Date();
  return isDateIntersectsWithFiscalYear(today, fiscalYear);
}
